module.exports = __webpack_public_path__ + "img/flex_screenshot_2.7b1b4f32.png";